import React from 'react';
import './Locations.css';

const Locations = () => {
  return (
    <div className="locations-page" id="locations-page">
      {/* Locations Hero Section */}
      <section className="locations-hero-section">
        <div className="locations-hero-container">
          {/* Left Column: Text & CTA */}
          <div className="locations-hero-content">
            <h1 className="locations-hero-title">We Are Right Here!</h1>
            <p className="locations-hero-desc">
              Al Quran Lesson is an online Quran academy providing online Quran classes with a single click all over the USA and Canada. We have been providing Islamic education for more than 16 years online worldwide. Our classes are designed for beginner-level to advanced levels. You just have to select your preferred timing and preferred tutor (male or female). We provide tutors who are qualified with great Quran teachings. Hundreds of families, parents, and students trust us.
            </p>
            <a href="/free-trial/" className="locations-hero-btn">
              GET 3 DAYS FREE TRIAL CLASSES
            </a>
          </div>

          {/* Right Column: Illustration Image */}
          <div className="locations-hero-image-col">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/location-moc.jpg`}
              alt="Al Quran Lesson Locations Mockup"
              className="locations-hero-img"
            />
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section
        className="locations-grid-section"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/location-bg.png')`
        }}
      >
        <div className="locations-grid-container">
          <div className="locations-grid-header">
            <h2 className="locations-grid-heading">Find Online Quran Classes In USA</h2>
            <div className="locations-grid-divider">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/pshape.png`}
                alt="Divider"
                className="locations-grid-divider-img"
              />
            </div>
          </div>

          <div className="locations-grid-glass-wrapper">
            <div className="locations-cards-grid">
              {/* Card 1: Texas */}
              <a href="/online-quran-classes-texas/" className="location-card">
                <div className="location-card__img-wrapper">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/38820f3ce4c4368710fdb2154a5bd3de.webp`}
                    alt="Online Quran Classes In Texas"
                    className="location-card__img"
                  />
                </div>
                <div className="location-card__content">
                  <h3 className="location-card__title">Online Quran Classes In Texas</h3>
                  <p className="location-card__desc">
                    Get Online Quran Classes in Texas and have balanced curricula to justify the busy lifestyles of individuals. Improve your Quran reading and tajweed to master Quran recitation in a reliable and friendly environment.
                  </p>
                  <span className="location-card__btn">
                    START LEARNING IN TEXAS
                  </span>
                </div>
              </a>

              {/* Card 2: New York */}
              <a href="/online-quran-classes-in-newyork/" className="location-card">
                <div className="location-card__img-wrapper">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/GettyImages-1429150390.jpg`}
                    alt="Online Quran Classes In New York"
                    className="location-card__img"
                  />
                </div>
                <div className="location-card__content">
                  <h3 className="location-card__title">Online Quran Classes In New York</h3>
                  <p className="location-card__desc">
                    Get Online Quran Classes in New York and have balanced curricula to justify the busy lifestyles of individuals. Improve your Quran reading and tajweed to master Quran recitation in a reliable and friendly environment.
                  </p>
                  <span className="location-card__btn">
                    START LEARNING IN NEWYORK
                  </span>
                </div>
              </a>

              {/* Card 3: Canada */}
              <a href="/online-quran-classes-canada/" className="location-card">
                <div className="location-card__img-wrapper">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/canadian-flag-flies-front-city-skyline-1536x1024-1.jpg`}
                    alt="Online Quran Classes In Canada"
                    className="location-card__img"
                  />
                </div>
                <div className="location-card__content">
                  <h3 className="location-card__title">Online Quran Classes In Canada</h3>
                  <p className="location-card__desc">
                    Get Online Quran Classes in Canada and have balanced curricula to justify the busy lifestyles of individuals. Improve your Quran reading and tajweed to master Quran recitation in a reliable and friendly environment.
                  </p>
                  <span className="location-card__btn">
                    START LEARNING IN CANADA
                  </span>
                </div>
              </a>

              {/* Card 4: California */}
              <a href="/online-quran-classes-california/" className="location-card">
                <div className="location-card__img-wrapper">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/la-jolla-california-veranda-best-places-to-visit-in-california-68d335dad6e1d.avif`}
                    alt="Online Quran Classes In California"
                    className="location-card__img"
                  />
                </div>
                <div className="location-card__content">
                  <h3 className="location-card__title">Online Quran Classes In California</h3>
                  <p className="location-card__desc">
                    Get Online Quran Classes in California and have balanced curricula to justify the busy lifestyles of individuals. Improve your Quran reading and tajweed to master Quran recitation in a reliable and friendly environment.
                  </p>
                  <span className="location-card__btn">
                    START LEARNING IN CALIFORNIA
                  </span>
                </div>
              </a>

              {/* Card 5: Florida */}
              <a href="/florida-online-quran-classes/" className="location-card">
                <div className="location-card__img-wrapper">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/online-quran-classes-california/florida.jpg`}
                    alt="Online Quran Classes In Florida"
                    className="location-card__img"
                  />
                </div>
                <div className="location-card__content">
                  <h3 className="location-card__title">Online Quran Classes In Florida</h3>
                  <p className="location-card__desc">
                    Get Online Quran Classes in Florida and have balanced curricula to justify the busy lifestyles of individuals. Improve your Quran reading and tajweed to master Quran recitation in a reliable and friendly environment.
                  </p>
                  <span className="location-card__btn">
                    START LEARNING IN FLORIDA
                  </span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section
        className="locations-cta-section"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/cta-bg.jpg')`
        }}
      >
        <div className="locations-cta-overlay"></div>
        <div className="locations-cta-container">
          <h3 className="locations-cta-heading">Start Your Free Trial Today!</h3>
          <p className="locations-cta-desc">
            Start your spiritual journey with Al Quran Lesson; Get a 3-day free trial session and improve your Quranic learning with certified tutors.
          </p>
          <a href="/free-trial/" className="locations-cta-btn">
            START FREE TRIAL
          </a>
        </div>
      </section>
      <br /><br /><br />
    </div>
  );
};

export default Locations;

